const initVideoIcon = {
  methods: {
    // this method targets the span containing the text / icon specified in props
    // will set appropriate classes and fire callback on click
    initVideoIcon(target, cb) {
      const targetSpan = document.querySelector(target)
      if (!targetSpan) return

      const icon = targetSpan.querySelector('img')

      // span styling
      targetSpan.classList.add(
        'inline-flex',
        'justify-center',
        'items-center',
        'cursor-pointer'
      )
      targetSpan.style.boxShadow = 'rgb(50 125 185) 0px 2px 0px -1px'
      targetSpan.style.color = ' rgba(50, 125, 185, 1)'
      targetSpan.style.fontWeight = 400
      targetSpan.style.lineHeight = '12px'

      // icon styling
      icon.style.width = '15px'
      icon.style.height = '11px'
      icon.style.marginLeft = '4px'
      icon.style.marginBottom = '1px'

      targetSpan.addEventListener('click', () => {
        cb && cb()
      })
    },
  },
}

export { initVideoIcon }
